import logo from "@/assets/ccob-logo.webp";
import logo96 from "@/assets/ccob-logo-96.webp";
import logo192 from "@/assets/ccob-logo-192.webp";
import coverAbout from "@/assets/cover-about.webp";
import coverAbout480 from "@/assets/cover-about-480.webp";
import coverAbout960 from "@/assets/cover-about-960.webp";
import coverServices from "@/assets/cover-services.webp";
import coverServices480 from "@/assets/cover-services-480.webp";
import coverServices960 from "@/assets/cover-services-960.webp";
import coverAccounting from "@/assets/cover-accounting.jpg";
import coverAccounting480 from "@/assets/cover-accounting-480.webp";
import coverAccounting960 from "@/assets/cover-accounting-960.webp";
import coverAuditing from "@/assets/cover-auditing.webp";
import coverAuditing480 from "@/assets/cover-auditing-480.webp";
import coverAuditing960 from "@/assets/cover-auditing-960.webp";
import coverTax from "@/assets/cover-tax.webp";
import coverTax480 from "@/assets/cover-tax-480.webp";
import coverTax960 from "@/assets/cover-tax-960.webp";
import coverResources from "@/assets/cover-resources.webp";
import coverResources480 from "@/assets/cover-resources-480.webp";
import coverResources960 from "@/assets/cover-resources-960.webp";
import coverBlog from "@/assets/cover-blog.webp";
import coverBlog480 from "@/assets/cover-blog-480.webp";
import coverBlog960 from "@/assets/cover-blog-960.webp";
import coverFaq from "@/assets/cover-faq.webp";
import coverFaq480 from "@/assets/cover-faq-480.webp";
import coverFaq960 from "@/assets/cover-faq-960.webp";
import coverContact from "@/assets/cover-contact.webp";
import coverContact480 from "@/assets/cover-contact-480.webp";
import coverContact960 from "@/assets/cover-contact-960.webp";
import coverTerms from "@/assets/cover-terms.webp";
import coverTerms480 from "@/assets/cover-terms-480.webp";
import coverTerms960 from "@/assets/cover-terms-960.webp";
import coverCities from "@/assets/cover-cities.webp";
import coverCities480 from "@/assets/cover-cities-480.webp";
import coverCities960 from "@/assets/cover-cities-960.webp";
import accounting from "@/assets/service-accounting.webp";
import accounting480 from "@/assets/service-accounting-480.webp";
import accounting960 from "@/assets/service-accounting-960.webp";
import auditing from "@/assets/service-auditing.webp";
import auditing480 from "@/assets/service-auditing-480.webp";
import auditing960 from "@/assets/service-auditing-960.webp";
import taxation from "@/assets/service-taxation.webp";
import taxation480 from "@/assets/service-taxation-480.webp";
import taxation960 from "@/assets/service-taxation-960.webp";
import payroll from "@/assets/service-payroll.jpg";
import payroll480 from "@/assets/service-payroll-480.webp";
import payroll960 from "@/assets/service-payroll-960.webp";
import taxPrep from "@/assets/service-tax-preparation.jpg";
import taxPrep480 from "@/assets/service-tax-preparation-480.webp";
import taxPrep960 from "@/assets/service-tax-preparation-960.webp";
import videoPoster from "@/assets/about-video-poster.jpg";
import videoPoster480 from "@/assets/about-video-poster-480.webp";
import videoPoster960 from "@/assets/about-video-poster-960.webp";
import founder from "@/assets/about-founder.jpg";
import founder480 from "@/assets/about-founder-480.webp";
import founder960 from "@/assets/about-founder-960.webp";
import office from "@/assets/about-office.jpg";
import office480 from "@/assets/about-office-480.webp";
import office960 from "@/assets/about-office-960.webp";
import clients from "@/assets/about-clients.jpg";
import clients480 from "@/assets/about-clients-480.webp";
import clients960 from "@/assets/about-clients-960.webp";
import realEstate from "@/assets/industry-realestate.jpg";
import realEstate480 from "@/assets/industry-realestate-480.webp";
import realEstate960 from "@/assets/industry-realestate-960.webp";
import healthcare from "@/assets/industry-healthcare.jpg";
import healthcare480 from "@/assets/industry-healthcare-480.webp";
import healthcare960 from "@/assets/industry-healthcare-960.webp";
import construction from "@/assets/industry-construction.jpg";
import construction480 from "@/assets/industry-construction-480.webp";
import construction960 from "@/assets/industry-construction-960.webp";
import hospitality from "@/assets/industry-hospitality.jpg";
import hospitality480 from "@/assets/industry-hospitality-480.webp";
import hospitality960 from "@/assets/industry-hospitality-960.webp";
import restaurants from "@/assets/industry-restaurants.jpg";
import restaurants480 from "@/assets/industry-restaurants-480.webp";
import restaurants960 from "@/assets/industry-restaurants-960.webp";
import retail from "@/assets/industry-retail.jpg";
import retail480 from "@/assets/industry-retail-480.webp";
import retail960 from "@/assets/industry-retail-960.webp";

export type ResponsiveImage = { srcSet: string; width: number; height: number };

const registry = new Map<string, ResponsiveImage>([
  [logo, { srcSet: `${logo96} 96w, ${logo192} 192w, ${logo} 300w`, width: 300, height: 300 }],
  ...[
    [coverAbout, coverAbout480, coverAbout960], [coverServices, coverServices480, coverServices960],
    [coverAccounting, coverAccounting480, coverAccounting960], [coverAuditing, coverAuditing480, coverAuditing960],
    [coverTax, coverTax480, coverTax960], [coverResources, coverResources480, coverResources960],
    [coverBlog, coverBlog480, coverBlog960], [coverFaq, coverFaq480, coverFaq960],
    [coverContact, coverContact480, coverContact960], [coverTerms, coverTerms480, coverTerms960],
    [coverCities, coverCities480, coverCities960],
  ].map(([src, small, medium]) => [src, { srcSet: `${small} 480w, ${medium} 960w, ${src} 1920w`, width: 1920, height: 1080 }] as const),
  ...[
    [accounting, accounting480, accounting960], [auditing, auditing480, auditing960], [taxation, taxation480, taxation960],
  ].map(([src, small, medium]) => [src, { srcSet: `${small} 480w, ${medium} 960w, ${src} 1024w`, width: 1024, height: 1024 }] as const),
  [payroll, { srcSet: `${payroll480} 480w, ${payroll960} 960w, ${payroll} 1536w`, width: 1536, height: 1024 }],
  [taxPrep, { srcSet: `${taxPrep480} 480w, ${taxPrep960} 960w, ${taxPrep} 1920w`, width: 1920, height: 1080 }],
  [videoPoster, { srcSet: `${videoPoster480} 480w, ${videoPoster960} 960w, ${videoPoster} 1920w`, width: 1920, height: 1080 }],
  [founder, { srcSet: `${founder480} 480w, ${founder960} 960w, ${founder} 1080w`, width: 1080, height: 1920 }],
  [office, { srcSet: `${office480} 480w, ${office960} 960w, ${office} 1920w`, width: 1920, height: 1080 }],
  [clients, { srcSet: `${clients480} 480w, ${clients960} 960w, ${clients} 1920w`, width: 1920, height: 1080 }],
  ...[
    [realEstate, realEstate480, realEstate960], [healthcare, healthcare480, healthcare960],
    [construction, construction480, construction960], [hospitality, hospitality480, hospitality960],
    [restaurants, restaurants480, restaurants960], [retail, retail480, retail960],
  ].map(([src, small, medium]) => [src, { srcSet: `${small} 480w, ${medium} 960w, ${src} 1024w`, width: 1024, height: 1024 }] as const),
]);

export function responsiveImage(src: string) {
  const registered = registry.get(src);
  if (registered) return registered;
  if (src.startsWith("https://images.unsplash.com/")) {
    const sized = (width: number) => {
      const url = new URL(src);
      url.searchParams.set("w", String(width));
      return url.toString();
    };
    return {
      srcSet: `${sized(480)} 480w, ${sized(960)} 960w, ${sized(1600)} 1600w`,
      width: 1600,
      height: 1200,
    };
  }
  return undefined;
}